import { UNIVERSAL_ROUTER_ADDRESS } from '@uniswap/universal-router-sdk'

/**
 * Safe wrapper: UNIVERSAL_ROUTER_ADDRESS throws for chains without a Universal Router
 * deployment (e.g. Robinhood Chain 4663, where swaps route through the KyberSwap router
 * instead). Render paths must not crash on such chains.
 */
export function getUniversalRouterAddress(chainId: number): string | undefined {
  try {
    return UNIVERSAL_ROUTER_ADDRESS(chainId)
  } catch {
    return undefined
  }
}
